import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import groupServices from '../services/groupServices';
import { currencyName, currencySymbol } from '../utils/money';
import { resolveLocale } from '../i18n';

/** Loads live currency list from Frankfurter (via our API) each mount. */
export function useCurrencies() {
  const { i18n } = useTranslation();
  const lng = resolveLocale(i18n.resolvedLanguage || i18n.language);
  const [currencies, setCurrencies] = useState([
    { code: 'ILS', name: currencyName('ILS', lng), symbol: currencySymbol('ILS') },
  ]);
  const [loading, setLoading] = useState(true);

  // Keyed on the language: the API names each currency in the caller's locale,
  // so switching language mid-session has to refetch or the picker keeps the
  // previous language's names.
  useEffect(() => {
    let alive = true;
    setCurrencies([{ code: 'ILS', name: currencyName('ILS', lng), symbol: currencySymbol('ILS') }]);
    groupServices.getCurrencies()
      .then((res) => {
        if (alive && res.currencies?.length) setCurrencies(res.currencies);
      })
      .catch(() => { /* keep ILS seed until retry */ })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [lng]);

  return { currencies, loading };
}
